import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=ae20109c&"
import script from "./LogoutIcon.vue?vue&type=script&lang=js&"
export * from "./LogoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports